import React, { useState } from 'react'
import sideImg from "../../../assets/images/confirmImg.jpg"
import moment from "moment"

const VerionHistory = ({ versions }) => {
 const [searchQuery, setSearchQuery] = useState("")

  const highlightText = (text) => {
    if (!searchQuery.trim()) return text
    const regex = new RegExp(`(${searchQuery})`, "gi")
    return text.replace(
      regex,
      `<mark style="background-color: #FFFF00; color: black; padding: 0 0px; border-radius: 3px;">$1</mark>`
    )
  }

  const filteredVersions = versions.filter(
    obj =>
      obj.date?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      obj.version?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      obj.description?.toLowerCase().includes(searchQuery.toLowerCase())
  )


  return (
     <div className="row d-flex justify-content-center align-items-center">
      <div className="col-md-4 d-flex justify-content-end align-items-center ps-3">
        <div className="text-center">
          <img src={sideImg} alt="Addepe" className="w-100" />
        </div>
      </div>
      <div className="col-md-8 d-flex flex-column">
        <div className="mb-4 d-flex justify-content-between align-items-center">
          <h5 className="text-purple mb-0">All Version History</h5>
          <div className="col-md-6">
            <input
              id="search-bar-0"
              type="text"
              className="form-control h-100"
              placeholder="Search..."
              value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)}
            />
          </div>
        </div>
        <div className="version-desc-sec">
          {filteredVersions.map((obj, i) => {
            const formattedDate = moment(obj.date).format("DD dddd MMMM YYYY")
            return (
              <div key={i}>
                <div
                  className="version-desc"
                  dangerouslySetInnerHTML={{
                    __html: `
                      <div class="d-flex justify-content-start align-items-center gap-2 mb-2">
                        <h5 class="mb-0 text-purple">Version: ${highlightText(obj.version)}</h5>
                        <span>|</span>
                        <h5 class="mb-0 text-purple">Date: ${highlightText(formattedDate)}</h5>
                      </div>
                      <div><p>${highlightText(obj.description)}</p></div>
                    `,
                  }}
                />
                <div className="seperator-version" />
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default VerionHistory
